<script>
    import axios from "axios";
    import pagination from './../pagination/Pagination';
    import productItem from './../inc/ProductItem';
    import filterProducts from "./../products/FilterProducts";
    import filterHelper from './filterHelper';

    export default {
        components: {
            pagination,
            productItem,
            filterProducts
        },
        mixins: [
            filterHelper
        ],
        props: {
            props_category: {
                required: true
            },
            props_child_categories: {
                required: false,
                default: null
            },
            props_products: {
                required: true
            },
            min_price: {
                required: true
            },
            max_price: {
                required: true
            }
        },
        data() {
            return {
                category: this.props_category,
                child_categories: this.props_child_categories,
                products_pagged: this.props_products,
                filter_query: [],
                loading: false,
                metaObject: null
            }
        },
        mounted() {
            this.searchMetaObject(false);
        },
        watch: {
            'products_pagged.current_page': function(val) {
                let url = new URL(window.location.href);
                let params = url.searchParams;
                if (val > 1) {
                    params.set('page', val);
                } else {
                    params.delete('page');
                }
                let new_url = url.toString();
                if (window.history.replaceState) {
                    window.history.replaceState('filter', document.title, new_url);
                }
            }
        },
        computed: {
            lastPage: function () {
                if (this.products_pagged.current_page == this.products_pagged.last_page) {
                    return true;
                }
            },
            limit: function () {
                if (window.innerWidth < 768) {
                    return 1;
                } 
                return 2;
            },
            filter_query_checked_defaults: function () {
                return this.filterNotDefaultParameters(this.filter_query);
            }
        },
        methods: {
            setFilterQuery(val) {
                this.filter_query = val;
            },
            filter(val) {
                this.filter_query = val;
                this.searchMetaObject();
                this.getPaginationResults();
            },
            searchMetaObject(titleSet = true) {
                // TODO set this object on back before load page, and mor then set by props
                let counter = 0,
                    watched = ['brands', 'countries'];
                
                if (this.filter_query) {
                    watched.forEach(parameter => {
                        let values = this.filter_query[parameter];
                        if (values && values.length > 0 && counter <= 1) {
                            counter = counter + values.length;
                            if (values.length == 1) {
                                this.setMetaObject(parameter, values[0]);
                            }
                        }
                    });
                }

                if (titleSet && counter !== 1) {
                    this.metaObject = null;
                    document.title = this.category.meta.title + ' ' + this.trans('seo.page_title_template');
                }
            },
            setMetaObject(parameter, id) {
                let object = {},
                    filter_parameter = this.category[parameter].filter(element =>  {
                        return element.id == id;
                    })[0];
                if (filter_parameter) {
                    object.h1 = this.category.meta.title + ' ' + filter_parameter.meta.title;
                    object.title = object.h1 + ' ' + this.trans('seo.filter_part_of_title');
                    object.description = this.trans('seo.filter_part_of_description_1') + ' ' + object.h1 + ' ' + this.trans('seo.filter_part_of_description_2');
                    
                    this.metaObject = object;
                    document.title = this.metaObject.title;
                }
            },
            getMoreResults() {
                if (!this.lastPage) {
                    clearTimeout(window.send);
                    this.loading = true;
                    window.send = setTimeout(()=>{
                    axios({
                        method: "post",
                        url: window.globalVariables.locale + "/get_filtered_products",
                        data: this.axioDataMore
                    }).then(response => {
                        this.products_pagged.current_page++;
                        this.products_pagged.data = this.products_pagged.data.concat(response.data.products.data);
                        this.loading = false;
                    });
                    }, 0);
                }
            },
            getPaginationResults(page = 1) {
                // clearTimeout(window.send);
                this.loading = true;
                // window.send = setTimeout(()=>{
                    axios({
                        method: "post",
                        url: window.globalVariables.locale + "/get_filtered_products",
                        data: this.axioDataPagination(page)
                    }).then(response => {
                        this.products_pagged = response.data.products;
                        
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                        this.loading = false;
                    });
                // }, 0);
            }
        }
    }
</script>